import type {
  TenkenData,
  TenkenKubun,
  Hantei,
  TenkenMaster,
} from 'src/models/extJunkaiTenkenReportTenkenData';

export interface TenkenDataResponse {
  id: number;
  base_id: string;
  detail_id: string;
  lat: string;
  lon: string;
  report_type: string;
  inspection_date: string;
  inspection_time: string;
  road_name: string;
  direction: string;
  place_name: string;
  landmark_number: string;
  inspection_type: string;
  damage_rank: string;
  photo_ids: string[];
  tenken_data_link: string;
}

export type JunkaiTenkenIndexResponse = TenkenDataResponse[];

export interface TenkenKubunResponse {
  id: number;
  tenken_kubun_id: string;
  tenkengyoumu_base_name: string;
  tenkengyoumu_detail_name: string;
  tenken_kubun_name: string;
}

export interface HanteiResponse {
  id: number;
  hantei: string;
}

export interface TenkenMasterResponse {
  tenken_kubuns: TenkenKubunResponse[];
  hanteis: HanteiResponse[];
}

export type JunkaiTenkenMasterResponse = TenkenMasterResponse;

export const toTenkenData = (response: TenkenDataResponse): TenkenData => ({
  id: response.id,
  baseId: response.base_id,
  detailId: response.detail_id,
  location: { lat: response.lat, lon: response.lon },
  reportType: response.report_type,
  inspectionDate: response.inspection_date,
  inspectionTime: response.inspection_time,
  roadName: response.road_name,
  direction: response.direction,
  placeName: response.place_name,
  landmarkNumber: response.landmark_number,
  inspectionType: response.inspection_type,
  damageRank: response.damage_rank,
  photoIds: response.photo_ids,
  tenkenDataLink: response.tenken_data_link,
});

export const toTenkenKubun = (response: TenkenKubunResponse): TenkenKubun => ({
  id: response.id,
  tenkenKubunId: response.tenken_kubun_id,
  tenkengyomuBaseName: response.tenkengyoumu_base_name,
  tenkengyomuDetailName: response.tenkengyoumu_detail_name,
  tenkenKubunName: response.tenken_kubun_name,
});

export const toHantei = (response: HanteiResponse): Hantei => ({
  id: response.id,
  hantei: response.hantei,
});

export const toTenkenMaster = (response: TenkenMasterResponse): TenkenMaster => ({
  tenkenKubuns: response.tenken_kubuns.map(toTenkenKubun),
  hanteis: response.hanteis.map(toHantei),
});
